"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../constants");
const SuccessPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, _react.default.createElement("path", {
  d: "M0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 C3.6,0 0,3.6 0,8 Z"
}), _react.default.createElement("polygon", {
  fill: "#FFFFFF",
  points: "6.5 11.9142136 3.58578644 9 5 7.58578644 6.5 9.08578644 11 4.58578644 12.4142136 6"
}))));
const SuccessMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9807773,5.38056166 18.6194383,0.0192227178 12,0 Z M10,17.414 L4.586,12 L6,10.586 L10,14.586 L18,6.586 L19.414,8 L10,17.414 Z"
})));
const AbstractSuccess = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(SuccessMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(SuccessPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractSuccess);